import React, { forwardRef, useImperativeHandle } from "react";
import CheckBox from "../CheckBox";

const ConfirmationModalCheckBox = forwardRef(
  ({ key, name, label, checked, setChecked }, ref) => {

    useImperativeHandle(ref, () => ({
      resetForm: () => setChecked(false), // custom method
    }));

    return (
      <div>
        <span className="confirm-modal-container">
          Note:
          <p>By disabling this shop, all associated POCs (Points of Contact) will be de-linked from the shop but will remain in the system.</p>
        </span>
        <div className="d-flex">
          <CheckBox
            key={key}
            name={name}
            label={label}
            value={checked}
            handleChange={(e) => setChecked(e.target.checked)}
          />
        </div>
      </div>
    );
  }
);

export default ConfirmationModalCheckBox;
